import { z } from "zod";

export const AddressModelSchema = z.object({
  dpid: z.string().nullable(),
  fullAddress: z.string().nullable(),
  sourceDesc: z.string().nullable(),
});
